import React, { useEffect, useState } from "react";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import { SearchSection } from "../../../components/Others/Layout/SearchSection";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NoData from "../../../components/NoData/Index";
import BuildingAdvancedSearch from "./BuildingAdvancedSearch";
import { toTitleCase } from "../../../components/utils/StringUtil";

export default function SubcategoryPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [subcategories, setSubcategories] = useState([]);
  const [bldMaterials, setBldMaterials] = useState([]);
  const [otherCategory, setOtherCategory] = useState([]);
  const [otherBrand, setOtherBrand] = useState([]);
  const [otherModels, setOtherModels] = useState([]);
  const [region, setRegion] = useState([]);
  const [advResults, setAdvResults] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  // Deduplicate helper
  const deduplicate = (arr, key = "_id") => {
    const seen = new Set();
    return arr.filter((item) => {
      const id = item[key] || item?._id;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  };

  useEffect(() => {
    if (location.state) {
      const { category, otherCategory, otherBrand, otherModels, region } = location.state;
      setSubcategories(category.subcategories || []);
      setOtherCategory(otherCategory || []);
      setOtherBrand(otherBrand || []);
      setOtherModels(otherModels || []);
      setRegion(region || []);
    }
  }, [location.state]);

  // Click a subcategory → go to product list page
  const SubcategoryBoxCard = ({ subcat }) => (
    <div
      className="category-item"
       onClick={() => {
    const existingParams = new URLSearchParams(location.search);

    existingParams.set("subcategoryId", subcat._id);

    navigate(`/others/products?${existingParams.toString()}`, {
      state: {
        subcategory: subcat,
        otherCategory,
        otherBrand,
        otherModels,
        region,
      },
    });
 }}

      
      style={{ cursor: "pointer" }}
    >
      <div className="d-flex flex-column align-items-center">
        <img
  src={subcat?.image || subcat?.images?.[0]}
  alt={subcat.name}
  style={{
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    marginBottom: "10px"
  }}
/>

        <h6>{toTitleCase(subcat.name)}</h6>
      </div>
    </div>
  );

  const PartCard = ({ material }) => (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
      <Link
        to={`/others/product/single/${material._id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="prod-div p-2 d-flex flex-column align-items-center"
          style={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            height: "100%",
          }}
        >
          {material?.photos?.length > 0 && (
            <img
              src={material.photos[0]?.url}
              alt={material.meterialName}
              style={{
                width: "100%",
                height: "180px",
                objectFit: "contain",
                marginBottom: "15px",
              }}
            />
          )}
          <h6 className="mb-2 text-center">{toTitleCase(material.meterialName)}</h6>
        </div>
      </Link>
    </div>
  );

  return (
    <div>
      <Header />
      <section id="inner-banner" style={{ width: "90%", margin: "auto" }}>
        <div className="container">
          <div className="bnr-div">
           <SearchSection
  selectedCategory={location.state?.filters?.categoryId}
  selectedBrand={location.state?.filters?.brandId}
  selectedManufacturer={location.state?.filters?.manufacturerId}
/>
          </div>

          <div className="row category-single-page-container">
            <div className="align-self-start col-lg-12">
              <button
                className="back btn btn-light"
                onClick={() => navigate(-1)}
                style={{
                  border: "none",
                  backgroundColor: "#dbe4f0ff",
                  padding: "8px 14px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-long-arrow-left"></i> Back
              </button>

              <h3 className="mt-3 mb-4">
                {location.state?.category ? toTitleCase(location.state.category.name) : "Subcategories"}
              </h3>

              <div className="category-grid">
                {subcategories.length > 0 ? (
                  subcategories.map((subcat) => <SubcategoryBoxCard key={subcat._id} subcat={subcat} />)
                ) : (
                  <NoData />
                )}
              </div>

              {/* Advanced Search Results (if any) */}
              {advResults.length > 0 && (
                <>
                  <h5 className="mt-4 mb-3">Advanced Search Results</h5>
                  <div className="row">
                    {deduplicate(advResults).map((material) => (
                      <PartCard key={material._id} material={material} />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
